import { EMPTY_NOTICE_CONFIG, type NoticeConfig } from '@rb/shared/notices';
import { pickFlavor, wrapFlavors } from '@rb/shared/r2-flavor';
import { callEdgeFunction } from '../supabase.client';

export function emptyNoticeConfig(): NoticeConfig {
  return structuredClone(EMPTY_NOTICE_CONFIG);
}

/** 현재 채널의 발행본 GET. 미발행이면 빈 config. */
export async function fetchNotices(channel: string): Promise<NoticeConfig> {
  const res = await callEdgeFunction<{ config: NoticeConfig | null }>('notices', { channel });
  return res.config ?? emptyNoticeConfig();
}

/** config 를 채널에 발행. */
export async function publishNotices(channel: string, config: NoticeConfig): Promise<void> {
  await callEdgeFunction('notices', { channel, config });
}

/** 현재 채널의 발행본을 web2/web3 분리해서 반환. 레거시 평탄 형태이면 양쪽 동일 값. */
export async function fetchNoticesFlavored(
  channel: string
): Promise<{ web2: NoticeConfig; web3: NoticeConfig }> {
  const res = await callEdgeFunction<{ config: unknown | null }>('notices', { channel });
  if (!res.config) return { web2: emptyNoticeConfig(), web3: emptyNoticeConfig() };
  return {
    web2: pickFlavor<NoticeConfig>(res.config, 'web2') ?? emptyNoticeConfig(),
    web3: pickFlavor<NoticeConfig>(res.config, 'web3') ?? emptyNoticeConfig(),
  };
}

/** web2/web3 를 nested 형태로 묶어 채널에 발행. */
export async function publishNoticesFlavored(
  channel: string,
  flavored: { web2: NoticeConfig; web3: NoticeConfig }
): Promise<void> {
  await callEdgeFunction('notices', { channel, config: wrapFlavors(flavored.web2, flavored.web3) });
}
